import { createSelector } from 'reselect';

export const getMobileScreenSize = createSelector(
  state => state.ui?.screenSize?.isMobile,
  isMobile => isMobile
);

export const getTabletSize = createSelector(
  state => state.ui?.screenSize?.isTablet,
  isTablet => isTablet
);

export const getMobileSidebarStatus = createSelector(
  state => state.ui?.showMobileSidebar,
  showMobileSidebar => showMobileSidebar
);

export const getShowSummary = createSelector(
  state => state.ui?.showSummary,
  showSummary => showSummary
);

export const getMobileHeaderRouteToDashboard = createSelector(
  state => state.ui?.mobileRouteToDashboard,
  mobileRouteToDashboard => mobileRouteToDashboard
);
